import React from "react";

export const Preloader = () => {
    return (
        <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="17.5017" cy="7.61874" r="3.85714" transform="rotate(-120 17.5017 7.61874)" fill="white" />
            <ellipse cx="4.92103" cy="24.0133" rx="3.85714" ry="3.85714" transform="rotate(-165 4.92103 24.0133)" fill="white" />
            <circle cx="7.61386" cy="44.4991" r="3.85714" transform="rotate(150 7.61386 44.4991)" fill="white" />
            <ellipse cx="24.0123" cy="57.079" rx="3.85714" ry="3.85714" transform="rotate(105 24.0123 57.079)" fill="white" />
            <circle cx="44.4983" cy="54.3832" r="3.85714" transform="rotate(60 44.4983 54.3832)" fill="white" />
            <ellipse cx="57.0751" cy="37.9887" rx="3.85714" ry="3.85714" transform="rotate(15 57.0751 37.9887)" fill="white" />
            <circle cx="54.3822" cy="17.5031" r="3.85714" transform="rotate(-30 54.3822 17.5031)" fill="white" />
            <ellipse cx="37.9877" cy="4.92298" rx="3.85714" ry="3.85714" transform="rotate(-75 37.9877 4.92298)" fill="white" />
        </svg>
    );
};
